"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderImageUrlFromPath = exports.renderReferenceStringAttribute = exports.handleRetrieveDeepModel = exports.handleListReferenceDetails = exports.handleListDataBasedOnModel = exports.jsonReviver = void 0;
var outline_1 = require("@heroicons/react/24/outline");
var moment_1 = __importDefault(require("moment"));
var react_1 = __importDefault(require("react"));
var readQuery_1 = require("./readQuery");
var isoDateRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*))(?:Z|(\+|-)([\d|:]*))?$/;
var jsonReviver = function (_, value) {
  if (typeof value !== "string") {
    return value;
  }
  if (isoDateRegex.exec(value)) {
    return (0, moment_1.default)(value).toDate();
  }
  return value;
};
exports.jsonReviver = jsonReviver;
/**
 * Used By List Feature
 */
var handleListDataBasedOnModel = function (data, server, dbModule, modelSchema, imageEndpoint, localURLEndpoint, collectionId, dbEndpoint, handleNavigate) {
  return __awaiter(void 0, void 0, void 0, function () {
    var dataList, referenceDetails;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          dataList = [];
          return [4 /*yield*/, (0, exports.handleListReferenceDetails)(data, modelSchema, dbModule, server, dbEndpoint)];
        case 1:
          referenceDetails = _a.sent();
          data.map(function (eachDataAttribute) {
            var _a, _b;
            var eachData = {};
            var eachNewData = JSON.parse(JSON.stringify(eachDataAttribute), exports.jsonReviver);
            var eachDataId = (_a = eachNewData["id"]) !== null && _a !== void 0 ? _a : eachNewData["_id"];
            var _loop_1 = function (eachKey, eachValue) {
              var model = modelSchema.find(function (eachAttribute) {
                return eachAttribute.id === eachKey;
              });
              switch (model === null || model === void 0 ? void 0 : model.type) {
                case "string":
                  if (eachKey === "id" || eachKey === "_id") {
                    eachData[eachKey] = eachValue;
                  } else {
                    eachData[eachKey] = typeof eachValue === "string" ? eachValue.length > 60 ? eachValue.substring(0, 60) + "..." : eachValue : eachValue;
                  }
                  break;
                case "date":
                case "number":
                case "boolean":
                case "address":
                case "object":
                case "list":
                case "multipleList":
                  eachData[eachKey] = eachValue;
                  break;
                case "image":
                  var url = (0, exports.renderImageUrlFromPath)(imageEndpoint, model.imageCollectionName, eachDataId, model.imageFileName, eachValue);
                  if (eachValue) {
                    eachData[eachKey] = react_1.default.createElement("img", {
                      src: url,
                      alt: "".concat(eachValue),
                      className: "w-10 h-10 object-contain"
                    });
                  } else {
                    eachData[eachKey] = " - ";
                  }
                  break;
                case "reference":
                  var currentReferenceData = referenceDetails[eachKey].find(function (eachDetail) {
                    return server === "mongoServer" ? eachDetail._id === eachValue : eachDetail.id === eachValue;
                  });
                  if (currentReferenceData) {
                    eachData[eachKey] = (_b = currentReferenceData[model.referenceLabel]) !== null && _b !== void 0 ? _b : (0, exports.renderReferenceStringAttribute)(currentReferenceData);
                  } else {
                    eachData[eachKey] = " - ";
                  }
                  break;
                case "listReference":
                  var referenceListLabel_1 = [];
                  if (Array.isArray(eachValue)) {
                    eachValue.map(function (value) {
                      var _a;
                      if (referenceDetails[eachKey]) {
                        var currentReferenceDetails = referenceDetails[eachKey].find(function (eachDetail) {
                          return server === "mongoServer" ? eachDetail._id === value : eachDetail.id === value;
                        });
                        if (currentReferenceDetails) {
                          referenceListLabel_1.push((_a = currentReferenceDetails[model.referenceLabel]) !== null && _a !== void 0 ? _a : (0, exports.renderReferenceStringAttribute)(currentReferenceDetails));
                        }
                      }
                      return null;
                    });
                  }
                  if (referenceListLabel_1.length === 0) {
                    referenceListLabel_1.push(" - ");
                  }
                  eachData[eachKey] = referenceListLabel_1;
                  break;
                default:
                  if (eachKey === "id" || eachKey === "_id") {
                    eachData[eachKey] = eachValue;
                  }
                  break;
              }
            };
            for (var _i = 0, _c = Object.entries(eachNewData); _i < _c.length; _i++) {
              var _d = _c[_i],
                eachKey = _d[0],
                eachValue = _d[1];
              _loop_1(eachKey, eachValue);
            }
            eachData["update"] = react_1.default.createElement(outline_1.PencilSquareIcon, {
              className: "w-5 text-primary-600",
              onClick: function (event) {
                var _a;
                event.preventDefault();
                event.stopPropagation();
                var id = (_a = eachData["id"]) !== null && _a !== void 0 ? _a : eachData["_id"];
                handleNavigate("".concat(localURLEndpoint, "?data=").concat(id, "&type=update&collection=").concat(collectionId, "&view=general"));
              }
            });
            dataList.push(server === "mongoServer" ? __assign(__assign({}, eachData), {
              id: eachData["_id"]
            }) : __assign({}, eachData));
            return null;
          });
          return [2 /*return*/, dataList];
      }
    });
  });
};
exports.handleListDataBasedOnModel = handleListDataBasedOnModel;
var handleListReferenceDetails = function (data, modelSchema, dbModule, server, dbEndpoint) {
  return __awaiter(void 0, void 0, void 0, function () {
    var referenceDetails_1, referenceCollection_1, referenceKey_1, responseData_1, err_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 3,, 4]);
          referenceDetails_1 = {};
          referenceCollection_1 = [];
          referenceKey_1 = [];
          return [4 /*yield*/, Promise.all(data.map(function (eachData) {
            var _a, _b;
            var _loop_2 = function (eachKey, eachValue) {
              var model = modelSchema.find(function (eachAttribute) {
                return eachAttribute.id === eachKey;
              });
              if (eachData) {
                switch (model === null || model === void 0 ? void 0 : model.type) {
                  case "reference":
                    if (referenceDetails_1[eachKey]) {
                      if (!referenceDetails_1[eachKey].includes(eachValue)) {
                        referenceDetails_1[eachKey].push(eachValue);
                      }
                    } else {
                      referenceDetails_1[eachKey] = [eachValue];
                      referenceKey_1.push(eachKey);
                      referenceCollection_1.push((_a = model.referenceSpaceId) !== null && _a !== void 0 ? _a : "");
                    }
                    break;
                  case "listReference":
                    if (Array.isArray(eachValue)) {
                      if (referenceDetails_1[eachKey]) {
                        var mergedSet = new Set(__spreadArray(__spreadArray([], eachValue, true), referenceDetails_1[eachKey], true));
                        referenceDetails_1[eachKey] = Array.from(mergedSet);
                      } else {
                        referenceDetails_1[eachKey] = __spreadArray([], eachValue, true);
                        referenceKey_1.push(eachKey);
                        referenceCollection_1.push((_b = model.referenceSpaceId) !== null && _b !== void 0 ? _b : "");
                      }
                    }
                    break;
                }
              }
            };
            for (var _i = 0, _c = Object.entries(eachData); _i < _c.length; _i++) {
              var _d = _c[_i],
                eachKey = _d[0],
                eachValue = _d[1];
              _loop_2(eachKey, eachValue);
            }
            return null;
          }))];
        case 1:
          _a.sent();
          responseData_1 = {};
          return [4 /*yield*/, Promise.all(referenceCollection_1.map(function (eachCollection, index) {
            return __awaiter(void 0, void 0, void 0, function () {
              var query, res;
              var _a;
              return __generator(this, function (_b) {
                switch (_b.label) {
                  case 0:
                    query = new readQuery_1.ReadQuery(dbModule, server, eachCollection, dbEndpoint);
                    return [4 /*yield*/, query.call({
                      type: "list",
                      query: [{
                        type: "in",
                        value: (_a = referenceDetails_1[referenceKey_1[index]]) !== null && _a !== void 0 ? _a : [],
                        queryId: server === "mongoServer" ? "_id" : "id"
                      }]
                    })];
                  case 1:
                    res = _b.sent();
                    responseData_1[referenceKey_1[index]] = res === null || res === void 0 ? void 0 : res.data;
                    return [2 /*return*/];
                }
              });
            });
          }))];

        case 2:
          _a.sent();
          return [2 /*return*/, responseData_1];
        case 3:
          err_1 = _a.sent();
          return [2 /*return*/, []];
        case 4:
          return [2 /*return*/];
      }
    });
  });
};

exports.handleListReferenceDetails = handleListReferenceDetails;
/**
 * Used By Read Feature
 */
var handleRetrieveDeepModel = function (newRespData, defaultModel, dbModule, server, dbEndpoint, schemaEndpoint, imageEndpoint, assetParentId, referenceModelSchema, setReferenceSchema, objectDataId) {
  return __awaiter(void 0, void 0, void 0, function () {
    var _loop_3, _i, _a, _b, eachKey, eachValue, err_2;
    var _c, _d, _e, _f;
    return __generator(this, function (_g) {
      switch (_g.label) {
        case 0:
          _g.trys.push([0, 5,, 6]);
          _loop_3 = function (eachKey, eachValue) {
            var model, _h, objectData, url, spaceQuery, schemaQuery, schemaRes, schemaStructure_1, spaceRes, _j, referenceAssetParentId_1, sortSpaceResData, listReferenceLabel_1, referenceData;
            return __generator(this, function (_k) {
              switch (_k.label) {
                case 0:
                  model = defaultModel.find(function (eachAttribute) {
                    return eachAttribute.id === eachKey;
                  });
                  if (!eachValue) return [3 /*break*/, 16];
                  _h = model === null || model === void 0 ? void 0 : model.type;
                  switch (_h) {
                    case "string":
                      return [3 /*break*/, 1];
                    case "date":
                      return [3 /*break*/, 1];
                    case "number":
                      return [3 /*break*/, 1];
                    case "boolean":
                      return [3 /*break*/, 1];
                    case "address":
                      return [3 /*break*/, 1];
                    case "list":
                      return [3 /*break*/, 1];
                    case "multipleList":
                      return [3 /*break*/, 1];
                    case "object":
                      return [3 /*break*/, 2];
                    case "image":
                      return [3 /*break*/, 4];
                    case "listReference":
                      return [3 /*break*/, 5];
                    case "reference":
                      return [3 /*break*/, 5];
                  }
                  return [3 /*break*/, 15];
                case 1:
                  newRespData[eachKey] = eachValue;
                  return [3 /*break*/, 16];
                case 2:
                  return [4 /*yield*/, (0, exports.handleRetrieveDeepModel)(eachValue, (_c = model.objectData) !== null && _c !== void 0 ? _c : [], dbModule, server, dbEndpoint, schemaEndpoint, imageEndpoint, assetParentId, referenceModelSchema, setReferenceSchema, model.id)];
                case 3:
                  objectData = _k.sent();
                  newRespData[eachKey] = objectData;
                  return [3 /*break*/, 16];
                case 4:
                  url = objectDataId ? (0, exports.renderImageUrlFromPath)(imageEndpoint, model.imageCollectionName + "%2F" + assetParentId, objectDataId, model.imageFileName, eachValue) : (0, exports.renderImageUrlFromPath)(imageEndpoint, model.imageCollectionName, assetParentId, model.imageFileName, eachValue);
                  newRespData[eachKey] = react_1.default.createElement("img", {
                    src: url,
                    alt: "".concat(model.id),
                    className: "w-10 h-10 object-contain"
                  });
                  return [3 /*break*/, 16];
                case 5:
                  spaceQuery = new readQuery_1.ReadQuery(dbModule, server, (_d = model.referenceSpaceId) !== null && _d !== void 0 ? _d : "", dbEndpoint);
                  schemaQuery = new readQuery_1.ReadQuery(dbModule, server, "space", schemaEndpoint);
                  return [4 /*yield*/, schemaQuery.call({
                    type: "get",
                    id: (_e = model.referenceSpaceId) !== null && _e !== void 0 ? _e : ""
                  })];
                case 6:
                  schemaRes = _k.sent();
                  schemaStructure_1 = (_f = schemaRes === null || schemaRes === void 0 ? void 0 : schemaRes.data) === null || _f === void 0 ? void 0 : _f.structure.filter(function (item) {
                    return item.type !== "reference" && item.type !== "listReference";
                  });
                  referenceModelSchema[eachKey] = schemaStructure_1;
                  setReferenceSchema(referenceModelSchema);
                  if (!(model.type === "listReference")) return [3 /*break*/, 8];
                  return [4 /*yield*/, spaceQuery.call({
                    type: "list",
                    query: [{
                      type: "in",
                      value: eachValue !== null && eachValue !== void 0 ? eachValue : [],
                      queryId: server === "mongoServer" ? "_id" : "id"
                    }]
                  })];
                case 7:
                  _j = _k.sent();
                  return [3 /*break*/, 10];
                case 8:
                  return [4 /*yield*/, spaceQuery.call({
                    type: "get",
                    id: typeof eachValue === "string" ? eachValue : ""
                  })];
                case 9:
                  _j = _k.sent();
                  _k.label = 10;
                case 10:
                  spaceRes = _j;
                  if (!(spaceRes === null || spaceRes === void 0 ? void 0 : spaceRes.data)) return [3 /*break*/, 14];
                  referenceAssetParentId_1 = server === "mongoServer" ? spaceRes === null || spaceRes === void 0 ? void 0 : spaceRes.data._id : spaceRes === null || spaceRes === void 0 ? void 0 : spaceRes.data.id;
                  if (!(Array.isArray(spaceRes.data) && Array.isArray(eachValue))) return [3 /*break*/, 12];
                  sortSpaceResData = spaceRes.data.sort(function (a, b) {
                    return eachValue.indexOf(server === "mongoServer" ? a._id : a.id) - eachValue.indexOf(server === "mongoServer" ? b._id : b.id);
                  });
                  listReferenceLabel_1 = [];
                  return [4 /*yield*/, Promise.all(sortSpaceResData.map(function (eachData) {
                    return __awaiter(void 0, void 0, void 0, function () {
                      var referenceData;
                      var _a, _b;
                      return __generator(this, function (_c) {
                        switch (_c.label) {
                          case 0:
                            return [4 /*yield*/, (0, exports.handleRetrieveDeepModel)(eachData, schemaStructure_1 !== null && schemaStructure_1 !== void 0 ? schemaStructure_1 : [], dbModule, server, dbEndpoint, schemaEndpoint, imageEndpoint, referenceAssetParentId_1, referenceModelSchema, setReferenceSchema)];
                          case 1:
                            referenceData = _c.sent();
                            listReferenceLabel_1.push((_b = referenceData[(_a = model.referenceLabel) !== null && _a !== void 0 ? _a : ""]) !== null && _b !== void 0 ? _b : (0, exports.renderReferenceStringAttribute)(referenceData));
                            return [2 /*return*/, null];
                        }
                      });
                    });
                  }))];
                case 11:
                  _k.sent();
                  newRespData[eachKey] = listReferenceLabel_1;
                  return [3 /*break*/, 14];
                case 12:
                  return [4 /*yield*/, (0, exports.handleRetrieveDeepModel)(spaceRes.data, schemaStructure_1 !== null && schemaStructure_1 !== void 0 ? schemaStructure_1 : [], dbModule, server, dbEndpoint, schemaEndpoint, imageEndpoint, referenceAssetParentId_1, referenceModelSchema, setReferenceSchema)];
                case 13:
                  referenceData = _k.sent();
                  newRespData[eachKey] = referenceData;
                  _k.label = 14;
                case 14:
                  return [3 /*break*/, 16];
                case 15:
                  return [3 /*break*/, 16];
                case 16:
                  return [2 /*return*/];
              }
            });
          };

          _i = 0, _a = Object.entries(newRespData);
          _g.label = 1;
        case 1:
          if (!(_i < _a.length)) return [3 /*break*/, 4];
          _b = _a[_i], eachKey = _b[0], eachValue = _b[1];
          return [5 /*yield**/, _loop_3(eachKey, eachValue)];
        case 2:
          _g.sent();
          _g.label = 3;
        case 3:
          _i++;
          return [3 /*break*/, 1];
        case 4:
          return [2 /*return*/, newRespData];
        case 5:
          err_2 = _g.sent();
          return [2 /*return*/, {}];
        case 6:
          return [2 /*return*/];
      }
    });
  });
};

exports.handleRetrieveDeepModel = handleRetrieveDeepModel;
var renderReferenceStringAttribute = function (value) {
  if (typeof value === "string") {
    return value;
  }
  var returnValue = "";
  for (var _i = 0, _a = Object.entries(value); _i < _a.length; _i++) {
    var _b = _a[_i],
      eachKey = _b[0],
      eachValue = _b[1];
    if (eachKey !== "_id" && eachKey !== "id" && typeof eachValue === "string") {
      returnValue = eachValue;
      break;
    }
  }
  return returnValue;
};
exports.renderReferenceStringAttribute = renderReferenceStringAttribute;
var renderImageUrlFromPath = function (pImageEndpoint, pImageCollection, pImageParentId, pImageFileName, pToken) {
  var imageEndpoint = pImageEndpoint !== null && pImageEndpoint !== void 0 ? pImageEndpoint : "";
  var imageCollection = pImageCollection !== null && pImageCollection !== void 0 ? pImageCollection : "";
  var imageParentId = pImageParentId !== null && pImageParentId !== void 0 ? pImageParentId : "";
  var imageFileName = pImageFileName !== null && pImageFileName !== void 0 ? pImageFileName : "";
  var url = imageEndpoint + imageCollection + "%2F" + imageParentId + "%2F" + imageFileName + "?alt=media&token=" + pToken;
  return url;
};
exports.renderImageUrlFromPath = renderImageUrlFromPath;